export default __webpack_public_path__ + "static/media/C_Carpet.05403a9d.jpg";